const PSEvents = require('PSEvents');
const BlockPaytableController = require('./BlockPaytableController');
cc.Class({
    extends: cc.Component,

    properties: {
        blockComponentName: 'BlockPrefabController'
    },

    onLoad () {
        this.blockController = this.node.getComponent(this.blockComponentName);

        if (!this.blockController) {
            cc.error('BlockPaytableAttacher: Cannot get block controller');
        }
    },

    onClick () {
        PSEvents.publish(BlockPaytableController.EVENT_BLOCK_CLICKED, this.blockController);
    },
});
